import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { PatchDocument } from '../../interfaces/patch-document';
import { UltimateBeneficialOwnershipRequestQuestionForUpdate } from '../../interfaces/ultimate-beneficial-ownership-request-questions/ultimate-beneficial-ownership-request-question-for-update';
import { UltimateBeneficialOwnershipRequestQuestion } from '../../interfaces/ultimate-beneficial-ownership-request-questions/ultimate-beneficial-ownership-request-question';


@Injectable({
  providedIn: 'root',
})
export class UltimateBeneficialOwnershipRequestQuestionService {
  protected _baseLink: string;

  constructor(
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig,
    private http: HttpClient,
  ) {
    this._baseLink = `${this.config.rootUrl}/UltimateBeneficialOwnership`;
  }

  public putUltimateBeneficialOwnershipRequestQuestion(ultimateBeneficialOwnershipRequestID: string, ultimateBeneficialOwnershipRequestQuestionID: string, ultimateBeneficialOwnershipRequestQuestion: UltimateBeneficialOwnershipRequestQuestionForUpdate): Observable<UltimateBeneficialOwnershipRequestQuestion> {
    return this.http.put<UltimateBeneficialOwnershipRequestQuestion>(`${this._baseLink}/${ultimateBeneficialOwnershipRequestID}/Questions/${ultimateBeneficialOwnershipRequestQuestionID}`, ultimateBeneficialOwnershipRequestQuestion);
  }

  public patchUltimateBeneficialOwnershipRequestQuestion(ultimateBeneficialOwnershipRequestID: string, ultimateBeneficialOwnershipRequestQuestionID: string, patchDocument: PatchDocument[]): Observable<UltimateBeneficialOwnershipRequestQuestion> {
    return this.http.patch<UltimateBeneficialOwnershipRequestQuestion>(`${this._baseLink}/${ultimateBeneficialOwnershipRequestID}/Questions/${ultimateBeneficialOwnershipRequestQuestionID}`, patchDocument);
  }
}
